export default "__VITE_PUBLIC_ASSET__8fae7795__"